import PropTypes from 'prop-types';

import styled from 'styled-components';

const StyledAnchor = styled.a`
   margin: 0 10px;
   display: block;
   text-decoration: none;
   color: #333333;
   :hover {
    color: #333333;
   }
`;

const TableCellWithLink = ({ className, linkURL, children }) => (
  <td className={className}>
    <StyledAnchor href={linkURL}>
      {children}
    </StyledAnchor>
  </td>
);

TableCellWithLink.propTypes = {
  className: PropTypes.string.isRequired,
  linkURL: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default TableCellWithLink;
